module.exports = __webpack_public_path__ + "img/ramallah-zoom-01.e5132945.png";